import RouteError from '@/components/ui/route-error';
import { createFileRoute } from '@tanstack/react-router';
import DashboardRouteLayout from '@/app/components/dashboard-route-layout';
import DashboardPlaceholder from '@/app/components/dashboard-placeholder';
import { DICTIONARY } from '@/config/dictionary';
import { requireAuth } from '@/utils/require-auth-before-load';

const DashboardSettingsPage = () => {
  return (
    <DashboardRouteLayout>
      <DashboardPlaceholder title={DICTIONARY.dashboard.navigation.settings} />
    </DashboardRouteLayout>
  );
};

export const Route = createFileRoute('/settings')({
  beforeLoad: requireAuth,
  component: DashboardSettingsPage,
  errorComponent: RouteError,
});
